import defaultSettings from '@/settings.js'
import { toast } from './message';

export function getAppTitle(pageTitle?: string) {
  const title = defaultSettings.title || 'Vue Element Admin'
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}

/**
 * 常数转换为选项
 *
 * @param constant 常数
 */
 export function constant2Option(constant: { [key: string]: { NAME: string; CODE: string | number } }) {
  if (!constant) {
    return []
  }
  const result:any = []
  for (const key of Object.keys(constant)) {
    const prop:any = constant[key]
    if ('NAME' in prop) {
      if ('CODE' in prop) {
        result.push({
          label: prop.NAME,
          value: prop.CODE
        }as any)
      }
    }
  }
  return result
}

export const debounce = (fn: any, delay: number) => {
  let timer: number | undefined = undefined;
  return function (this: any) {
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  }
}

/**
 * 处理el-table的ResizeObserver loop limit exceeded问题
 */
export function solveResizeObserverLoopLimitExceededErr() {
  const _ResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends _ResizeObserver{
    constructor(callback: ResizeObserverCallback) {
      callback = debounce(callback, 16);
      super(callback);
    }
  }
}

export function formatter(code: { [key: string | symbol]: { NAME: string; CODE: string }}, value: string) {
  const item = Reflect.ownKeys(code).find(key => code[key].CODE === value)
  if(item) {
    return code[item].NAME
  }
  return ''
}

export function formatterDate(originalTimeString: string):string {

  // 创建一个新的日期对象
  const originalDate = new Date(originalTimeString);
  // 提取日期和时间的各个部分
  const year = originalDate.getFullYear();
  const month = ('0' + (originalDate.getMonth() + 1)).slice(-2); // 月份从0开始，需要加1
  const day = ('0' + originalDate.getDate()).slice(-2);
  const hours = ('0' + originalDate.getHours()).slice(-2);
  const minutes = ('0' + originalDate.getMinutes()).slice(-2);
  const seconds = ('0' + originalDate.getSeconds()).slice(-2);
  // 格式化时间
  const formattedTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
  
  return formattedTime
}

/**
 * 判断是否只有一条数据
 * @param data 数据集
 * @param show 是否提示消息
 * @returns 
 */
export function isOnlyOne(data: any[], show = true) {
  if(data.length > 1) {
    if(show) {
      toast.warn('最多只能选择一条信息')
    }
    return false
  }
  if(data.length < 1) {
    if(show) {
      toast.warn('请选择一条信息')
    }
    return false
  }
  return true
}

/**
 * 通用工具函数
 * @author Jay Qing
 * @since 2021/05/24
 */

 const INDEX_NOT_FOUND = -1

 /**
  * 获取连个字符串之间的字符串
  *
  * @param src 原字符串
  * @param open 起始字符串
  * @param close 结束字符串
  * @return {string} 原字符串的起始字符串与结束字符串之间的字符串
  */
 export function substringBetween(src: string, open: string, close: string) {
   if (!isTypeOfString(src) ||
     !isTypeOfString(open) ||
     !isTypeOfString(close)) {
     return ''
   }
   const start = src.indexOf(open)
   if (start === INDEX_NOT_FOUND) {
     return ''
   }
   const end = src.indexOf(close, start + open.length)
   if (end === INDEX_NOT_FOUND) {
     return ''
   }
   return src.substring(start + open.length, end)
 }
 
 export function isTypeOfString(data: string) {
   return isTypeOf(data, 'string')
 }
 
 export function isTypeOf(data: string, type: string) {
   return typeof data === type
 }
 

 export function formatRouter(str: string) {
  return str.replace(/-([a-z])/g,  (match, letter) => {
    return letter.toUpperCase();
    }).replace(/^([a-z])/g, (match, letter) => {
        return letter.toUpperCase();
    });
  
 }